import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { OrderDetailService } from '../../services/order-detail.service'
import { Payment, PaymentItem } from 'depoto-core/src/entities'

@Component({
  selector: 'app-payment-info-search',
  templateUrl: './payment-info-search.component.html',
  styleUrls: ['./payment-info-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PaymentInfoSearchComponent implements OnInit {
  constructor(public orderDetailService: OrderDetailService) {}

  ngOnInit() {
    if (this.orderDetailService.queryCheckouts.data()?.length === 1) {
      this.orderDetailService.order.checkout = this.orderDetailService.queryCheckouts.data()[0]
    }
    if (this.orderDetailService.queryPayments.data()?.length === 1) {
      const payment = this.orderDetailService.queryPayments.data()[0]
      const paymentItem = this.orderDetailService.order.paymentItems[0]
      if (paymentItem) {
        paymentItem.payment = payment
      } else {
        this.orderDetailService.order.paymentItems.push(new PaymentItem({ payment, amount: 0, isPaid: false }))
      }
    }
    if (this.orderDetailService.queryCompanyCarriers.data()?.length === 1) {
      this.orderDetailService.order.carrier = this.orderDetailService.queryCompanyCarriers.data()[0]
    }
  }

  public paymentSelected(payment: Payment): void {
    const paymentItem = this.orderDetailService.order.paymentItems[0]
    if (paymentItem) {
      paymentItem.payment = new Payment(payment)
    } else {
      this.orderDetailService.order.paymentItems.push(
        new PaymentItem({
          payment: new Payment(payment),
          amount: 0,
          isPaid: false,
        })
      )
    }
  }
}
